import React from "react"
const Stats = ({ data }) => {
    return (
      <div className="market-stats">
        {data.map((item, index) => (
          <div key={index}>
            <div>
              <span>{item.name}</span>
              <span>{item.value}</span> 
            </div>
          </div>
        ))}
      </div>
    );
  };
  

export default Stats;


